(function () {
	'use strict';
	$(document).ready(function () {

		$(".play-video").modalVideo({
			channel: 'vimeo'
		});

		$('.form-tabs .form-tabs-nav a').on('click', function (e) {
			e.preventDefault();
			var itemIndex = $(this).parent().index();
			$(this).addClass('active');
			$(this).parent().siblings().children().removeClass('active');


			$('.form-tabs .form-tabs-wrapper .form-tab').find('form, form input, form button, form .contactpage-form-popup').each(function () {
				if ($(this).attr('id')) {
					var currId = $(this).attr('id');
					var newId = currId.replace('-disabled', '') + '-disabled';
					$(this).attr('id', newId);
				}

				if ($(this).attr('name')) {
					var currName = $(this).attr('name');
					var newName = currName.replace('-disabled', '') + '-disabled';
					$(this).attr('name', newName);
				}
			});


			$('.form-tabs .form-tabs-wrapper .form-tab').eq(itemIndex).find('form, form input, form button, form .contactpage-form-popup').each(function () {

				if ($(this).attr('id')) {
					var currId = $(this).attr('id');
					$(this).attr('id', currId.replace('-disabled', ''));
				}

				if ($(this).attr('name')) {
					var currName = $(this).attr('name');
					$(this).attr('name', currName.replace('-disabled', ''));
				}
			});

			$('.form-tabs .form-tabs-wrapper .form-tab').eq(itemIndex).show();
			$('.form-tabs .form-tabs-wrapper .form-tab').eq(itemIndex).siblings().hide();

			$('.ajax-success').hide();
			$('.ajax-loading').hide();
			$('.ajax-error').hide();
		});

		//Section CTA
		var swiperHomeCTA = new Swiper('.swiper-cta', {
			loop: true,
			autoplay: {
				delay: 3000
			},
			pagination: {
				el: '.swiper-cta .swiper-pagination',
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">0' + (index + 1) + '</span>';
				},
			},
			navigation: {
				nextEl: '.swiper-cta .swiper-button-next',
				prevEl: '.swiper-cta .swiper-button-prev',
			},
		});

		var swiperNumbersBG = new Swiper('.swiper-numbers-bg', {
			loop: true,
			pagination: {
				el: '.section-numbers-bg .swiper-pagination',
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">0' + (index + 1) + '</span>';
				},
			},
		});

		//Section support
		var swiperSupport = new Swiper('.swiper-links', {
			loop: true,
		});

		//Section trusted
		var swiperTrusted = new Swiper('.swiper-trusted', {
			freeMode: true,
			loop: true,
			slidesPerView: 5,
			speed: 5000,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},
			breakpoints: {
				1024: {
					slidesPerView: 4,
				},
				768: {
					slidesPerView: 3,
				},
				576: {
					slidesPerView: 2,
				},
				375: {
					slidesPerView: 1,
				}
			}
		});

		$('.section-renewables svg #CLICK path, .section-renewables svg #CLICK polygon').on('mouseover', function () {
			var renewable_id = $(this).attr('id');
			if (window.matchMedia("(min-width: 992px)").matches) {
				$('.info-popup[data-popup=' + renewable_id + ']').fadeIn().siblings().hide();
			} else {
				$('.info-popup[data-popup=' + renewable_id + ']').slideDown().siblings().slideUp();
			}
			$(this).addClass('active').siblings().removeClass('active');
		});

	});
}(jQuery));
